import { sendEvent } from '../../../../analytics-library/entry/sendEvent';
import { LegacyEvent } from '../../../../analytics-library/events/LegacyEvent/LegacyEvent';
import { WidgetsLoaded } from '../../../../analytics-library/events/WidgetsLoaded';
import type Localiser from '../../../../core/modules/Localiser';
import type { Site } from '../../../../core/modules/sites/Site';
import type { PlatformData } from '../../../../core/types/PlatformData';
import { captureMetrics } from '../../../../hawklinks/browser/metrics';
import { initiateApstagIntegration } from '../../../../sharedModules/apstag/integration';
import {
  CURRENT_WIDGET_PLACEHOLDER_CLASS,
  WIDGET_PLACEHOLDER_CLASSES,
} from '../../../../utils/constants';
import { updateHawk } from '../../../../utils/global';

import { createAppearedEvent } from './createAppearedEvent';
import { ProcessedWidget, processWidget } from './processWidget';

export const resolveWidgets = async ({
  unprocessedWidgets,
  platformData,
  site,
  localiser,
  editorialOnPage,
}: {
  unprocessedWidgets: HTMLElement[];
  platformData: PlatformData;
  site: Site;
  localiser: Localiser;
  editorialOnPage: boolean;
}): Promise<void> => {
  const processedWidgets: ProcessedWidget[] = [];

  for (const unprocessedWidget of unprocessedWidgets) {
    const index = unprocessedWidgets.indexOf(unprocessedWidget);

    // Normalize old widget placeholder class names to the current one
    unprocessedWidget.classList.remove(...WIDGET_PLACEHOLDER_CLASSES);
    unprocessedWidget.classList.add(CURRENT_WIDGET_PLACEHOLDER_CLASS);

    const newProcessedWidget = await processWidget({
      element: unprocessedWidget,
      site,
      articleType: platformData.articleType,
      articleId: platformData.articleId,
      keywords: platformData.keywords,
      territory: platformData.territory,
      articleName: document.title,
      articleUrl: document.location.href,
      localiser,
      editorialOnPage,
      index,
    });

    if (newProcessedWidget) {
      processedWidgets.push(newProcessedWidget);
    }
  }

  updateHawk({
    widgetsLoaded: true,
  });

  captureMetrics({
    platform: site.platform,
    type: 'widgets',
  });

  sendEvent(
    new LegacyEvent({
      data: createAppearedEvent({ processedWidgets }),
    }),
  );
  sendEvent(
    new WidgetsLoaded({
      processedWidgets,
    }),
  );

  initiateApstagIntegration();
};
